'use client'

import Image from 'next/image'
import Link from 'next/link'
import { useMemo } from 'react'

import { ZEditorJsRenderer } from '@/_components/universal/editorjs-renderer/z-editorjs-renderer'
import { getFullName } from '@/_lib/utils'
import { IEmployee } from '@/_types/employee'
import { IJob } from '@/_types/jobs'
import { hasValidContentBlocks } from '@/app/[locale]/ambulance/[slug]/utils/content.utils'

interface IProps {
	job: IJob
}

export function AJobEmployeeCard({ employee }: { employee: IEmployee | null }) {
	if (!employee) return null

	return (
		<div className='pdt-20 pdb-20 editorjs-renderer--normal'>
			<div className='editorjs-renderer_block'>
				<div className='flex items-center gap-8'>
					{employee.photo.url ? (
						<div className='relative aspect-[1/1] w-full max-w-[105px] shrink-0'>
							<Image
								unoptimized={true}
								src={employee.photo.url}
								alt={getFullName(employee)}
								height={105}
								width={105}
								quality={75}
								className='object-cover rounded-full w-full h-full'
							/>
						</div>
					) : (
						<div className='aspect-[1/1] object-cover rounded-full w-full max-w-[105px] shrink-0 bg-gray-300'></div>
					)}

					<div>
						<h2 className='!text-2xl !m-0 !mb-1'>{getFullName(employee)}</h2>
						<p className='text-base font-light mb-2'>{employee.position}</p>

						<Link
							href={`mailto:hrmedante@medante.sk`}
							className='font-light hover:underline'
						>
							hrmedante@medante.sk
						</Link>
					</div>
				</div>
			</div>
		</div>
	)
}

export default function AJobContent({ job }: IProps) {
	const hasContent = useMemo(() => {
		return job.content && hasValidContentBlocks(job.content)
	}, [job.content])

	if (!hasContent) {
		return null
	}

	return (
		<section className='pdt-60lg pdt-80 pdb-20lg pdb-80 box_amb box_job'>
			<div className='wrapper'>
				<ZEditorJsRenderer
					data={job.content}
					className='editorjs-renderer--normal pb-10!'
				/>
			</div>
			<AJobEmployeeCard employee={job.responsibleEmployee} />
		</section>
	)
}
